import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      background: 'var(--c-bg-main)',
      padding: '120px 24px 60px',
    }}
  >
    <div style={{ maxWidth: '500px' }}>
      <h1
        style={{
          fontSize: 'clamp(80px, 10vw, 120px)',
          color: 'var(--c-gold)',
          lineHeight: 1,
          marginBottom: '24px',
        }}
      >
        404
      </h1>
      <h2 style={{ marginBottom: '16px' }}>Page not found</h2>
      <p style={{ fontSize: '18px', marginBottom: '32px' }}>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable. Let's get you back on track.
      </p>
      <Link to="/" className="btn-primary">
        Return to Home
      </Link>
    </div>
  </motion.div>
);

export default NotFound;
